<form class="itinerary-model-content-inner" [formGroup]="templateDetailsForm">
  <div class="itinerary-model-content">
    <div class="ion-no-padding mb-1">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Customize Template</ion-title>
    </div>
  
    <div class="form-container ion-padding-horizontal">
      <!-- <div class="row">
        <div class="col-6">
          <div class="input-container">
            <label for="" class="label">Template Name</label>
            <div>
              <input type="text" placeholder="Ex- Tour to goa" class="input" formControlName="templateName">
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="input-container">
            <label for="" class="label">Template Title</label>
            <div>
              <input type="text" placeholder="Ex- Tour to goa" class="input" formControlName="templateTitle">
            </div>
          </div>
        </div>
      </div> -->

      <div class="row">
        <div class="col-4">
          <div class="input-container">
            <label for="" class="label">Cover Page</label>
            <div>
              <input type="file" accept=".png, .jpg, .jpeg" class="input" (change)="onFileSelected($event, 'image1')">
            </div>
            <div class="img-container">
              <img [src]="getImgUrl(templateDetailsForm.get('image1')?.value)" alt="">
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="input-container">
            <label for="" class="label">Emergency Phone Number 1*</label>
            <div [ngClass]="{ 'invalid-input': templateDetailsForm.get('enquiryNumber1')?.invalid && templateDetailsForm.get('enquiryNumber1')?.touched }">
              <app-phone-country-input formControlName="enquiryNumber1"></app-phone-country-input>
            </div>
          </div>  
        </div>
      
        <div class="col-4">
          <div class="input-container">
            <label for="" class="label">Emergency Phone Number 2*</label>
            <div [ngClass]="{ 'invalid-input': templateDetailsForm.get('enquiryNumber2')?.invalid && templateDetailsForm.get('enquiryNumber2')?.touched }">
              <app-phone-country-input formControlName="enquiryNumber2"></app-phone-country-input>
            </div>
          </div>  
        </div>


      </div>
      
      <div class="row">
        
      </div>
      
      <div class="row">
        
      </div>
      
    </div>
  </div>
  
  <!-- <div class="ion-padding-horizontal bg-light-gray itinerary-model-footer justify-content-end">
    <ion-button class="unfilled-blue-btn" type="button" (click)="goPrevious()">
      Previous
    </ion-button>
    <div class="d-flex justify-content-end">
      <ion-button type="button" class="filled-blue-btn" (click)="goNext()">
        <ion-text>Next</ion-text>
      </ion-button>
    </div>
    
  </div> -->

  <div class="ion-padding-horizontal bg-light-gray itinerary-model-footer justify-content-center">
    <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()" data-toggle="tooltip" data-placement="top" title="Tooltip on top">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>
